import { Button } from '@/components/ui/deprecated-button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { cn } from '@/lib/css-utils'
import { ArrowLeft } from 'lucide-react'
import type { HTMLAttributes } from 'react'

const DrawerHeader = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => (
  <DrawerTitle
    className={cn(
      'text-lg font-semibold flex justify-center items-center border-b border-modal-header-border pt-4 pb-2 relative',
      className,
    )}
    {...rest}
  >
    <DrawerClose asChild>
      <Button
        variant="outline"
        className="absolute left-4"
        customType="icon"
        size="sm"
        onClick={() => {}}
      >
        <ArrowLeft className="stroke-modal-header-back self-start" size="12" />
      </Button>
    </DrawerClose>
    {children}
  </DrawerTitle>
)
DrawerHeader.displayName = 'DrawerHeader'

function CustomDrawerContent({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <DrawerContent
      className={cn(
        'w-full bg-modal-bg rounded-none border-0 h-full flex flex-col',
        className,
      )}
      {...rest}
    >
      {children}
    </DrawerContent>
  )
}

CustomDrawerContent.displayName = 'DrawerContent'

export {
  Drawer,
  DrawerPortal,
  DrawerOverlay,
  DrawerTrigger,
  CustomDrawerContent as DrawerContent,
  DrawerHeader,
  DrawerFooter,
  DrawerDescription,
}
